/* Super Socks Cart Drawer
 * Ersetzt den Turbo-Mini-Cart: öffnet sich beim Klick aufs Warenkorb-Symbol
 * und nach jedem "In den Warenkorb". Zeigt Gratisversand-Leiste, das Gratis-Goodie
 * (nur Anzeige – kein Artikel) und das voraussichtliche Zustelldatum.
 * Wird wegen InstantClick nur einmal ausgeführt (data-no-instant); das Markup
 * wird bei jedem Seitenwechsel neu gerendert und daher immer frisch gesucht.
 */
(function () {
  'use strict';
  if (window.SSDrawer) return;

  var root = function () { return document.getElementById('ss-drawer'); };
  var $ = function (sel) { var r = root(); return r ? r.querySelector(sel) : null; };
  var lastTrigger = null;
  var busy = false;
  var lastPct = 0;

  function cfg(name, fallback) {
    var r = root();
    var v = r && r.getAttribute('data-' + name);
    return v === null || v === undefined || v === '' ? fallback : v;
  }

  function isCartPage() {
    return /(^|\s)cart(\s|$)/.test(document.body.className) || /\/cart\/?$/.test(location.pathname);
  }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  /* Schwelle in Shop-Währung → aktuelle Währung (Märkte) */
  function threshold() {
    var base = parseInt(cfg('threshold', 2500), 10);
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return rate && rate > 0 ? Math.round(base * rate) : base;
  }

  /* ---------- Daten ---------- */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function removeKey(key) { return postJSON('/cart/change.js', { id: key, quantity: 0 }); }

  /* ---------- Gratis-Goodie (nur Anzeige) ----------
     Das Goodie steht im Warenkorb, ist aber kein Artikel: Es taucht weder im Checkout noch in der
     Bestellung auf und wird von Hand beigelegt. Bild, Titel, Wert und Größe kommen aus dem Snippet
     (#ss-gift-data). */
  function gift() {
    var el = document.getElementById('ss-gift-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function sameCode(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }

  /* Altlast der früheren Plus-Button-Version: Goodie-Artikel (Property _gratis_goodie) und
     Gratis-Code aus bestehenden Warenkörben entfernen, damit nichts davon im Checkout landet */
  function isGiftLine(item) { return !!(item.properties && item.properties._gratis_goodie); }
  function cleanup(cart) {
    var g = gift();
    var lines = cart.items.filter(isGiftLine);
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var hasCode = !!(g && g.code && codes.some(function (c) { return sameCode(c, g.code); }));
    if (!lines.length && !hasCode) return Promise.resolve(cart);
    return lines.reduce(function (p, l) { return p.then(function () { return removeKey(l.key); }); }, Promise.resolve())
      .then(function () {
        if (!hasCode) return null;
        var others = codes.filter(function (c) { return !sameCode(c, g.code); });
        return postJSON('/cart/update.js', { discount: others.join(',') });
      })
      .then(getCart);
  }
  function safeCleanup(cart) {
    return cleanup(cart).catch(function () { return getCart(); });
  }

  /* Zur Kasse: Rabattcodes in der Checkout-Adresse mitgeben – Codes, die nur im Warenkorb
     gesetzt sind, gehen sonst beim Domainwechsel verloren (z. B. Vorschau-Link auf shopifypreview.com) */
  function goCheckout() {
    var btn = $('.ss-drawer__checkout');
    if (btn) btn.disabled = true;
    var g = gift();
    getCart()
      .then(function (cart) {
        var codes = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable && !(g && g.code && sameCode(d.code, g.code)); })
          .map(function (d) { return d.code; });
        window.location.href = '/checkout' + (codes.length ? '?discount=' + codes.map(encodeURIComponent).join(',') : '');
      })
      .catch(function () {
        var form = $('.ss-drawer__form');
        if (form) form.submit(); else window.location.href = '/checkout';
      });
  }

  /* ---------- Zustelldatum (gleiche Logik wie auf der Produktseite) ---------- */
  var countryPromise = null;
  function getCountry() {
    if (countryPromise) return countryPromise;
    var cached = null;
    try { cached = sessionStorage.getItem('ssCountry'); } catch (e) {}
    if (cached) { countryPromise = Promise.resolve(cached); return countryPromise; }
    countryPromise = fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        c = c || (window.Shopify && Shopify.country) || 'AT';
        try { sessionStorage.setItem('ssCountry', c); } catch (e) {}
        return c;
      })
      .catch(function () { return (window.Shopify && Shopify.country) || 'AT'; });
    return countryPromise;
  }

  function addBusinessDays(days) {
    var date = new Date();
    var count = 0;
    while (count < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) count++;
    }
    var weekday = date.toLocaleString('de-DE', { weekday: 'short' });
    var day = date.toLocaleString('de-DE', { day: 'numeric' });
    var month = date.toLocaleString('de-DE', { month: 'short' });
    return weekday + '. ' + day + ' ' + month;
  }

  function renderDelivery() {
    getCountry().then(function (country) {
      var box = $('[data-ss-delivery]');
      var txt = $('[data-ss-delivery-text]');
      if (!box || !txt) return;
      var days = parseInt(country === 'AT' ? cfg('delay-at', 2) : cfg('delay-other', 3), 10);
      txt.innerHTML = 'Heute bestellen – Zustellung am <strong>' + esc(addBusinessDays(days)) + '</strong>';
      box.hidden = false;
    });
  }

  /* ---------- Rendering ---------- */
  var ICON_TRUCK = '<svg class="ss-ship__icon" width="24" height="24" viewBox="0 0 28 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M1.5 8.5h3.5M2.5 12h2.5"/><rect x="7" y="4" width="11" height="12" rx="1"/><path d="M18 8h4l3 4v4h-7"/>' +
    '<circle cx="11" cy="18" r="2"/><circle cx="21.5" cy="18" r="2"/></svg>';
  var ICON_HOME = '<svg class="ss-ship__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 11l9-7 9 7"/><path d="M5 9.5V20h14V9.5"/><path d="M10 20v-6h4v6"/></svg>';
  var ICON_GIFT = '<svg class="ss-goodie__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/>' +
    '<path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  var ICON_CHECK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var TRASH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';

  function renderShipping(cart) {
    var el = $('[data-ss-ship]');
    if (!el) return;
    if (!cart.item_count) { el.innerHTML = ''; return; }
    var goal = threshold();
    var rest = goal - cart.total_price;
    var pct = Math.max(0, Math.min(100, cart.total_price / goal * 100));
    var done = rest <= 0;
    var text = done
      ? 'Geschafft! Versand ist kostenlos.'
      : 'Noch ' + money(rest) + ' bis zum kostenlosen Versand.';
    /* Aufbau wie bei Waterdrop: LKW – Balken – Haus, Text darunter */
    el.innerHTML =
      '<div class="ss-ship' + (done ? ' is-done' : '') + '">' +
        '<div class="ss-ship__bar">' + ICON_TRUCK +
          '<div class="ss-ship__track" role="progressbar" aria-label="Fortschritt bis zum kostenlosen Versand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '">' +
            '<div class="ss-ship__fill" style="width:' + lastPct + '%"></div>' +
          '</div>' + ICON_HOME +
        '</div>' +
        '<p class="ss-ship__text">' + text + '</p>' +
      '</div>';
    /* vom letzten Stand aus animieren; Reflow statt rAF, damit es auch ohne Frame-Callback greift */
    var fill = el.querySelector('.ss-ship__fill');
    void fill.offsetWidth;
    fill.style.width = pct + '%';
    lastPct = pct;
  }

  function itemImage(item) {
    if (!item.image) return '';
    var src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    return '<img src="' + esc(src) + '" alt="" width="64" height="64" decoding="async">';
  }

  /* "Größe: 36-40" aus den Optionen der Variante */
  function variantText(item) {
    var parts = (item.options_with_values || []).filter(function (o) {
      return o.value && o.value !== 'Default Title' && o.name !== 'Title';
    }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); });
    if (parts.length) return parts.join(' · ');
    return item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
  }

  function renderItem(item) {
    var key = esc(item.key);
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (v && k.charAt(0) !== '_') props += '<p class="ss-item__prop">' + esc(k) + ': ' + esc(v) + '</p>';
      });
    }
    if (item.selling_plan_allocation) {
      props += '<p class="ss-item__prop">' + esc(item.selling_plan_allocation.selling_plan.name) + '</p>';
    }
    /* Streichpreis bei jedem Rabatt: Produkt-Rabatte (z. B. WELCOME15%) und den Anteil von
       Bestell-Rabatten (z. B. TEAM-Codes per QR-Code), den Shopify je Zeile in total_discount meldet */
    var was = item.original_line_price;
    var off = typeof item.total_discount === 'number' ? item.total_discount : was - item.final_line_price;
    var now = Math.max(0, was - off);
    var price = now < was
      ? '<span class="ss-item__price ss-item__price--sale"><span class="ss-item__was">' + money(was) + '</span>' + money(now) + '</span>'
      : '<span class="ss-item__price">' + (now > 0 ? money(now) : 'Gratis') + '</span>';

    /* Zwei Zeilen: Titel + Preis | Größe + Menge + Löschen */
    return '<li class="ss-item" data-key="' + key + '">' +
      '<a class="ss-item__img" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + itemImage(item) + '</a>' +
      '<div class="ss-item__main">' +
        '<div class="ss-item__top">' +
          '<a class="ss-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + price +
        '</div>' +
        props +
        '<div class="ss-item__bottom">' +
          '<span class="ss-item__variant">' + variantText(item) + '</span>' +
          '<div class="ss-item__actions">' +
            '<div class="ss-qty">' +
              '<button type="button" class="ss-qty__btn" data-ss-qty="' + (item.quantity - 1) + '" data-key="' + key + '" aria-label="Menge verringern">−</button>' +
              '<span class="ss-qty__val" aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" class="ss-qty__btn" data-ss-qty="' + (item.quantity + 1) + '" data-key="' + key + '" aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<button type="button" class="ss-item__remove" data-ss-qty="0" data-key="' + key + '" aria-label="' + esc(item.product_title) + ' entfernen">' + TRASH + '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  /* Gratis-Goodie im Stil von Waterdrop – fest dabei, sobald ein Produkt im Warenkorb liegt */
  function renderGoodie(cart) {
    var g = gift();
    if (!g) return '';
    if (!cart.items.some(function (i) { return !isGiftLine(i); })) return '';
    var v = (g.variants || [])[0];
    var img = g.image ? '<img src="' + esc(g.image) + '" alt="" width="56" height="56" decoding="async">' : '';
    var value = (v && v.price) || g.price;
    return '<div class="ss-goodie is-added">' +
      '<p class="ss-goodie__head">' + ICON_GIFT + 'Gratis-Goodie</p>' +
      '<div class="ss-goodie__box">' +
        '<span class="ss-goodie__img">' + img + '</span>' +
        '<div class="ss-goodie__info">' +
          '<p class="ss-goodie__title">' + esc(g.title) + '</p>' +
          '<div class="ss-goodie__meta">' +
            '<span class="ss-goodie__now">' + money(0) + '</span>' +
            '<span class="ss-goodie__was">' + money(value) + '</span>' +
            (v ? '<span class="ss-goodie__size-text">Größe: ' + esc(v.title) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<div class="ss-goodie__action">' +
          '<span class="ss-goodie__btn is-added" role="img" aria-label="Liegt der Bestellung bei">' + ICON_CHECK + '</span>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderEmpty() {
    return '<div class="ss-empty">' +
      '<p class="ss-empty__title">Der Warenkorb ist leer</p>' +
      '<p class="ss-empty__text">Zu jeder Bestellung gibt’s ein Gratis-Goodie dazu.</p>' +
      '<a class="ss-empty__btn" href="' + esc(cfg('shop-link', '/collections/all')) + '">Socken entdecken</a>' +
    '</div>';
  }

  function render(cart, opts) {
    var body = $('[data-ss-body]');
    var foot = $('[data-ss-foot]');
    if (!body || !foot) return;
    var count = $('[data-ss-count]');
    if (count) count.textContent = cart.item_count === 1 ? '1 Produkt' : cart.item_count + ' Produkte';

    renderShipping(cart);

    if (!cart.item_count) {
      body.innerHTML = renderEmpty();
      foot.hidden = true;
    } else {
      var html = '<ul class="ss-drawer__items">';
      cart.items.forEach(function (item) { if (!isGiftLine(item)) html += renderItem(item); });
      html += '</ul>' + renderGoodie(cart);
      body.innerHTML = html;
      foot.hidden = false;
      if (opts && opts.pop) {
        var box = body.querySelector('.ss-goodie__box');
        if (box) box.classList.add('is-pop');
      }

      $('[data-ss-subtotal]').textContent = money(cart.total_price);
      /* Nur echte Rabatte zählen als Ersparnis */
      var savings = cart.original_total_price - cart.total_price;
      var sBox = $('[data-ss-savings]');
      if (savings > 0) {
        $('[data-ss-savings-value]').textContent = '−' + money(savings);
        sBox.hidden = false;
      } else {
        sBox.hidden = true;
      }
      renderDelivery();
    }

    syncTheme(cart);
  }

  /* Fehlermeldung über dem Kassenbereich */
  var toastTimer = null;
  function toast(msg, type) {
    var el = $('[data-ss-toast]');
    if (!el) return;
    var foot = $('[data-ss-foot]');
    el.style.bottom = ((foot && !foot.hidden ? foot.offsetHeight : 0) + 12) + 'px';
    el.className = 'ss-drawer__toast ss-drawer__toast--' + (type === 'error' ? 'error' : 'success');
    el.innerHTML = (type === 'error' ? '' : ICON_CHECK) + '<span>' + esc(msg) + '</span>';
    void el.offsetWidth;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, type === 'error' ? 5000 : 3200);
  }

  /* Warenkorb-Zähler und die Versandleiste auf der Produktseite mitziehen */
  function syncTheme(cart) {
    document.querySelectorAll('.cart_count').forEach(function (el) { el.textContent = cart.item_count; });
    var goal = threshold();
    var pct = Math.min(100, cart.total_price / goal * 100);
    var rest = (goal - cart.total_price) / 100;
    var msg = rest <= 0 ? 'Kostenloser Versand' : 'Noch ' + Math.round(rest) + ' EUR bis zum kostenlosen Versand';
    document.querySelectorAll('.free-shipping').forEach(function (bar) {
      if (bar.closest('#ss-drawer')) return;
      var p = bar.querySelector('.free-shipping__progress');
      var t = bar.querySelector('.free-shipping__text span');
      if (p) p.style.width = pct + '%';
      if (t) t.textContent = msg;
    });
  }

  function changeLine(key, qty) {
    if (busy || !key) return;
    busy = true;
    var r = root();
    r.classList.add('is-loading');
    postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(safeCleanup)
      .then(function (cart) { render(cart); })
      .catch(function (err) {
        toast((err && (err.description || err.message)) || 'Das hat leider nicht geklappt.', 'error');
        return getCart().then(function (c) { render(c); });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var r2 = root();
        if (r2) r2.classList.remove('is-loading');
      });
  }

  /* ---------- Öffnen / Schließen ---------- */
  /* Nur in der Theme-Vorschau: Shopifys Vorschauleiste ist ein Popover in der Top Layer und liegt
     damit über jedem z-index. Der Drawer geht dort beim Öffnen ebenfalls in die Top Layer (nach der
     Leiste, also darüber), damit er wirklich den ganzen Bildschirm füllt. Im Live-Shop gibt es die
     Leiste nicht – dort bleibt alles beim normalen z-index. */
  var hideTimer = null;
  function previewBar() { return document.getElementById('PBarNextFrameWrapper'); }

  function open(opts) {
    var r = root();
    if (!r) return;
    return getCart().then(safeCleanup).then(function (cart) {
      var panel = r.querySelector('.ss-drawer__panel');
      clearTimeout(hideTimer);
      render(cart, opts);
      var bar = previewBar();
      /* einmal Popover, immer Popover – sonst bliebe er per Browser-Standard unsichtbar, falls die Leiste inzwischen weg ist */
      if ((bar || r.hasAttribute('popover')) && typeof r.showPopover === 'function') {
        if (!r.hasAttribute('popover')) r.setAttribute('popover', 'manual');
        if (!r.matches(':popover-open')) {
          r.showPopover();
          void r.offsetWidth; /* Startposition rendern, damit das Hereingleiten animiert */
        }
      } else if (bar && panel) {
        panel.style.bottom = Math.round(bar.getBoundingClientRect().height) + 'px'; /* ältere Browser */
      }
      r.classList.add('is-open');
      r.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ss-drawer-lock');
      if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    });
  }

  function close() {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ss-drawer-lock', 'blocked-scroll', 'is-active');
    document.querySelectorAll('.cart-container.active_link').forEach(function (el) { el.classList.remove('active_link'); });
    if (r.hasAttribute('popover')) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        var r2 = root();
        if (r2 && !r2.classList.contains('is-open') && r2.matches(':popover-open')) r2.hidePopover();
      }, 320);
    }
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  /* ---------- Events ---------- */
  /* Capture-Phase: fängt den Klick ab, bevor Turbo sein Dropdown öffnet */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r || isCartPage()) return;
    var trigger = e.target.closest && e.target.closest('.mini_cart, a[href="/cart"], a[href$="/cart"]');
    if (trigger && !r.contains(trigger)) {
      e.preventDefault();
      e.stopPropagation();
      lastTrigger = trigger;
      open();
      return;
    }
    if (!r.contains(e.target)) return;
    if (e.target.closest('[data-ss-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('.ss-drawer__checkout')) { e.preventDefault(); goCheckout(); return; }
    var q = e.target.closest('[data-ss-qty]');
    if (q) {
      e.preventDefault();
      changeLine(q.getAttribute('data-key'), Math.max(0, parseInt(q.getAttribute('data-ss-qty'), 10)));
    }
  }, true);

  /* Zurück aus dem Checkout (Back-Forward-Cache): Kasse-Button wieder freigeben */
  window.addEventListener('pageshow', function () {
    var btn = $('.ss-drawer__checkout');
    if (btn) btn.disabled = false;
  });

  document.addEventListener('keydown', function (e) {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = r.querySelectorAll('.ss-drawer__panel a[href], .ss-drawer__panel button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Jeder erfolgreiche Add-to-Cart (Turbo nutzt jQuery/XHR, Apps oft fetch) öffnet den Drawer */
  var addTimer = null;
  function isAddUrl(url) { return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || '')); }
  function onAdded(body) {
    if (isCartPage()) return;
    /* Testprodukte mit Empfehlungskarte (ss-empfehlungen.js): die Karte übernimmt, der Drawer bleibt zu */
    try { if (window.SSEmpfehlung && window.SSEmpfehlung.uebernimm(body)) return; } catch (e) {}
    clearTimeout(addTimer);
    addTimer = setTimeout(function () { open({ pop: true }); }, 80);
  }

  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._ssUrl = url;
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (isAddUrl(xhr._ssUrl)) {
      xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) onAdded(body); });
    }
    return xSend.apply(this, arguments);
  };

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (isAddUrl(url)) p.then(function (res) { if (res.ok) onAdded(init && init.body); }).catch(function () {});
      return p;
    };
  }

  window.SSDrawer = {
    open: open,
    close: close,
    refresh: function () { return getCart().then(safeCleanup).then(function (c) { render(c); }); },
    checkout: goCheckout
  };
})();
